import { render, staticRenderFns } from "./AiComponentText.vue?vue&type=template&id=785d48c8&scoped=true"
import script from "./AiComponentText.vue?vue&type=script&lang=js"
export * from "./AiComponentText.vue?vue&type=script&lang=js"
import style0 from "./AiComponentText.vue?vue&type=style&index=0&id=785d48c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d48c8",
  null
  
)

export default component.exports